import { FC } from 'react';
import { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';
import { CatInlineNotification } from '@blocks-react/components/InlineNotification';

interface Title {
  NOTIFICATIONS_ERROR: string;
}

export const NotificationDetailError: FC<Title> = ({ NOTIFICATIONS_ERROR }) => {
  return (
    <CatInlineNotification
      variant="error"
      heading={NOTIFICATIONS_ERROR}
      dismissible={false}
      data-testid="ErrorIcon"
    >
      <CatIconWarningCircle slot="before" />
    </CatInlineNotification>
  );
};
